// Generated by generate.mjs. Edit the generator, then regenerate.
import type { CSSProperties } from "react";
function geometryStyle(
  value: CSSProperties & Record<`--${string}`, string | number>,
) {
  return value;
}
export function SendGeometry() {
  return (
    <span
      className="send-visual"
      aria-hidden="true"
      style={geometryStyle({
        "--nose-z": "0.4166666666666667em",
        "--tail-z": "-0.4166666666666667em",
        "--rear-z": "-0.16025641025641024em",
      })}
    >
      <span className="send-form">
        <span className="send-flight">
          <svg
            className="send-side"
            viewBox="0 0 0.6666666666666666 0.8975274678557507"
            style={geometryStyle({
              width: "0.6666666666666666em",
              height: "0.8975274678557507em",
              transform:
                "translate3d(-0.3333333333333333em,-0.3333333333333333em,-0.4166666666666667em) matrix3d(1,0,0,0,0,0.3713906763541037,0.9284766908852594,0,0,-0.9284766908852594,0.3713906763541037,0,0,0,0,1)",
            })}
          >
            <path d="M0.3333333333333333 0.8975274678557507 0 0 0.3333333333333333 0.27616229780176943 0.6666666666666666 0 Z" />
          </svg>
          <svg
            className="send-side"
            viewBox="0 0 0.6666666666666666 0.8975274678557507"
            style={geometryStyle({
              width: "0.6666666666666666em",
              height: "0.8975274678557507em",
              transform:
                "translate3d(0.3333333333333333em,-0.3333333333333333em,-0.4166666666666667em) matrix3d(0,1,0,0,-0.3713906763541037,0,0.9284766908852594,0,0.9284766908852594,0,0.3713906763541037,0,0,0,0,1)",
            })}
          >
            <path d="M0.3333333333333333 0.8975274678557507 0 0 0.3333333333333333 0.27616229780176943 0.6666666666666666 0 Z" />
          </svg>
          <svg
            className="send-side"
            viewBox="0 0 0.6666666666666666 0.8975274678557507"
            style={geometryStyle({
              width: "0.6666666666666666em",
              height: "0.8975274678557507em",
              transform:
                "translate3d(0.3333333333333333em,0.3333333333333333em,-0.4166666666666667em) matrix3d(-1,0,0,0,0,-0.3713906763541037,0.9284766908852594,0,0,0.9284766908852594,0.3713906763541037,0,0,0,0,1)",
            })}
          >
            <path d="M0.3333333333333333 0.8975274678557507 0 0 0.3333333333333333 0.27616229780176943 0.6666666666666666 0 Z" />
          </svg>
          <svg
            className="send-side"
            viewBox="0 0 0.6666666666666666 0.8975274678557507"
            style={geometryStyle({
              width: "0.6666666666666666em",
              height: "0.8975274678557507em",
              transform:
                "translate3d(-0.3333333333333333em,0.3333333333333333em,-0.4166666666666667em) matrix3d(0,-1,0,0,0.3713906763541037,0,0.9284766908852594,0,-0.9284766908852594,0,0.3713906763541037,0,0,0,0,1)",
            })}
          >
            <path d="M0.3333333333333333 0.8975274678557507 0 0 0.3333333333333333 0.27616229780176943 0.6666666666666666 0 Z" />
          </svg>
          <span
            className="send-set"
            style={geometryStyle({ "--set-delay": "0s" })}
          >
            <span
              className="send-particle"
              style={geometryStyle({
                "--wing-x": "-0.3333333333333333em",
                "--wing-y": "-0.3333333333333333em",
                "--notch-x": "0em",
                "--notch-y": "-0.23076923076923075em",
              })}
            >
              <i className="send-billboard send-trace-dot"></i>
            </span>
            <span
              className="send-particle"
              style={geometryStyle({
                "--wing-x": "0.3333333333333333em",
                "--wing-y": "-0.3333333333333333em",
                "--notch-x": "0.23076923076923075em",
                "--notch-y": "0em",
              })}
            >
              <i className="send-billboard send-trace-dot"></i>
            </span>
            <span
              className="send-particle"
              style={geometryStyle({
                "--wing-x": "0.3333333333333333em",
                "--wing-y": "0.3333333333333333em",
                "--notch-x": "0em",
                "--notch-y": "0.23076923076923075em",
              })}
            >
              <i className="send-billboard send-trace-dot"></i>
            </span>
            <span
              className="send-particle"
              style={geometryStyle({
                "--wing-x": "-0.3333333333333333em",
                "--wing-y": "0.3333333333333333em",
                "--notch-x": "-0.23076923076923075em",
                "--notch-y": "0em",
              })}
            >
              <i className="send-billboard send-trace-dot"></i>
            </span>
            <span
              className="send-square-travel"
              style={geometryStyle({ "--flame-delay": "0s" })}
            >
              <span className="send-square-shape">
                <span className="send-billboard">
                  <i
                    className="send-edge send-square-edge"
                    style={geometryStyle({
                      "--wire-ink": "0.32573",
                      transform:
                        "translate3d(0.065em,0em,0em) rotateZ(2.356194490192345rad) rotateY(0rad) scaleX(0.09192388155425119)",
                    })}
                  ></i>
                  <i
                    className="send-edge send-square-edge"
                    style={geometryStyle({
                      "--wire-ink": "0.35427",
                      transform:
                        "translate3d(0em,0.065em,0em) rotateZ(-2.356194490192345rad) rotateY(0rad) scaleX(0.09192388155425119)",
                    })}
                  ></i>
                  <i
                    className="send-edge send-square-edge"
                    style={geometryStyle({
                      "--wire-ink": "0.35427",
                      transform:
                        "translate3d(-0.065em,0em,0em) rotateZ(-0.7853981633974483rad) rotateY(0rad) scaleX(0.09192388155425119)",
                    })}
                  ></i>
                  <i
                    className="send-edge send-square-edge"
                    style={geometryStyle({
                      "--wire-ink": "0.32573",
                      transform:
                        "translate3d(0em,-0.065em,0em) rotateZ(0.7853981633974483rad) rotateY(0rad) scaleX(0.09192388155425119)",
                    })}
                  ></i>
                </span>
              </span>
            </span>
            <span
              className="send-square-travel"
              style={geometryStyle({ "--flame-delay": "0.45s" })}
            >
              <span className="send-square-shape">
                <span className="send-billboard">
                  <i
                    className="send-edge send-square-edge"
                    style={geometryStyle({
                      "--wire-ink": "0.33232",
                      transform:
                        "translate3d(0.035em,0em,0em) rotateZ(2.356194490192345rad) rotateY(0rad) scaleX(0.04949747468305833)",
                    })}
                  ></i>
                  <i
                    className="send-edge send-square-edge"
                    style={geometryStyle({
                      "--wire-ink": "0.34768",
                      transform:
                        "translate3d(0em,0.035em,0em) rotateZ(-2.356194490192345rad) rotateY(0rad) scaleX(0.04949747468305833)",
                    })}
                  ></i>
                  <i
                    className="send-edge send-square-edge"
                    style={geometryStyle({
                      "--wire-ink": "0.34768",
                      transform:
                        "translate3d(-0.035em,0em,0em) rotateZ(-0.7853981633974483rad) rotateY(0rad) scaleX(0.04949747468305833)",
                    })}
                  ></i>
                  <i
                    className="send-edge send-square-edge"
                    style={geometryStyle({
                      "--wire-ink": "0.33232",
                      transform:
                        "translate3d(0em,-0.035em,0em) rotateZ(0.7853981633974483rad) rotateY(0rad) scaleX(0.04949747468305833)",
                    })}
                  ></i>
                </span>
              </span>
            </span>
          </span>
          <span
            className="send-set"
            style={geometryStyle({ "--set-delay": "0.9s" })}
          >
            <span
              className="send-particle"
              style={geometryStyle({
                "--wing-x": "-0.3333333333333333em",
                "--wing-y": "-0.3333333333333333em",
                "--notch-x": "0em",
                "--notch-y": "-0.23076923076923075em",
              })}
            >
              <i className="send-billboard send-trace-dot"></i>
            </span>
            <span
              className="send-particle"
              style={geometryStyle({
                "--wing-x": "0.3333333333333333em",
                "--wing-y": "-0.3333333333333333em",
                "--notch-x": "0.23076923076923075em",
                "--notch-y": "0em",
              })}
            >
              <i className="send-billboard send-trace-dot"></i>
            </span>
            <span
              className="send-particle"
              style={geometryStyle({
                "--wing-x": "0.3333333333333333em",
                "--wing-y": "0.3333333333333333em",
                "--notch-x": "0em",
                "--notch-y": "0.23076923076923075em",
              })}
            >
              <i className="send-billboard send-trace-dot"></i>
            </span>
            <span
              className="send-particle"
              style={geometryStyle({
                "--wing-x": "-0.3333333333333333em",
                "--wing-y": "0.3333333333333333em",
                "--notch-x": "-0.23076923076923075em",
                "--notch-y": "0em",
              })}
            >
              <i className="send-billboard send-trace-dot"></i>
            </span>
            <span
              className="send-square-travel"
              style={geometryStyle({ "--flame-delay": "0.9s" })}
            >
              <span className="send-square-shape">
                <span className="send-billboard">
                  <i
                    className="send-edge send-square-edge"
                    style={geometryStyle({
                      "--wire-ink": "0.32573",
                      transform:
                        "translate3d(0.065em,0em,0em) rotateZ(2.356194490192345rad) rotateY(0rad) scaleX(0.09192388155425119)",
                    })}
                  ></i>
                  <i
                    className="send-edge send-square-edge"
                    style={geometryStyle({
                      "--wire-ink": "0.35427",
                      transform:
                        "translate3d(0em,0.065em,0em) rotateZ(-2.356194490192345rad) rotateY(0rad) scaleX(0.09192388155425119)",
                    })}
                  ></i>
                  <i
                    className="send-edge send-square-edge"
                    style={geometryStyle({
                      "--wire-ink": "0.35427",
                      transform:
                        "translate3d(-0.065em,0em,0em) rotateZ(-0.7853981633974483rad) rotateY(0rad) scaleX(0.09192388155425119)",
                    })}
                  ></i>
                  <i
                    className="send-edge send-square-edge"
                    style={geometryStyle({
                      "--wire-ink": "0.32573",
                      transform:
                        "translate3d(0em,-0.065em,0em) rotateZ(0.7853981633974483rad) rotateY(0rad) scaleX(0.09192388155425119)",
                    })}
                  ></i>
                </span>
              </span>
            </span>
            <span
              className="send-square-travel"
              style={geometryStyle({ "--flame-delay": "1.35s" })}
            >
              <span className="send-square-shape">
                <span className="send-billboard">
                  <i
                    className="send-edge send-square-edge"
                    style={geometryStyle({
                      "--wire-ink": "0.33232",
                      transform:
                        "translate3d(0.035em,0em,0em) rotateZ(2.356194490192345rad) rotateY(0rad) scaleX(0.04949747468305833)",
                    })}
                  ></i>
                  <i
                    className="send-edge send-square-edge"
                    style={geometryStyle({
                      "--wire-ink": "0.34768",
                      transform:
                        "translate3d(0em,0.035em,0em) rotateZ(-2.356194490192345rad) rotateY(0rad) scaleX(0.04949747468305833)",
                    })}
                  ></i>
                  <i
                    className="send-edge send-square-edge"
                    style={geometryStyle({
                      "--wire-ink": "0.34768",
                      transform:
                        "translate3d(-0.035em,0em,0em) rotateZ(-0.7853981633974483rad) rotateY(0rad) scaleX(0.04949747468305833)",
                    })}
                  ></i>
                  <i
                    className="send-edge send-square-edge"
                    style={geometryStyle({
                      "--wire-ink": "0.33232",
                      transform:
                        "translate3d(0em,-0.035em,0em) rotateZ(0.7853981633974483rad) rotateY(0rad) scaleX(0.04949747468305833)",
                    })}
                  ></i>
                </span>
              </span>
            </span>
          </span>
        </span>
      </span>
    </span>
  );
}
